<template>
  <ClientOnly>
    <BaseLayoutWithSidebar :use-gray-background="true" class="py-0!">
      <div class="h-full bg-no-repeat pb-31 flow-background">
        <div class="px-4 py-12 md:p-16 max-w-180 space-y-4">
          <div class="md:hidden">
            <slot name="mobile-progress" />
          </div>
          <slot />
        </div>
      </div>

      <FixedFlowFooterBar
        v-if="$slots.footer"
        content-max-width-class="max-w-180"
        :offset-for-sidebar="true"
      >
        <slot name="footer" />
      </FixedFlowFooterBar>

      <template #sidebar>
        <div class="px-6 my-8 py-8 sticky top-0">
          <VerticalStepProgressBar :steps="steps" :current-step="currentStep" />
        </div>
        <div v-if="showLogoutButton" class="px-2">
          <button
            type="button"
            class="group flex items-center px-2 py-2 text-base-med font-medium rounded-md lg:leading-6 text-primary-0 hover:text-white hover:bg-primary-5 w-full"
            @click.prevent="$emit('logout')"
          >
            <LogoutIcon class="mr-2 shrink-0 h-4 w-4 text-fp-gray-4" />
            <span class="text-sm text-fp-gray-4">Logout</span>
          </button>
        </div>
      </template>
    </BaseLayoutWithSidebar>
  </ClientOnly>
</template>

<script setup lang="ts">
import BaseLayoutWithSidebar from './base-layout-with-sidebar.vue'
import FixedFlowFooterBar from '../components/common/FixedFlowFooterBar.vue'
import VerticalStepProgressBar from '../components/common/VerticalStepProgressBar.vue'
import LogoutIcon from '../components/icons/figma/LogoutIcon.vue'

withDefaults(
  defineProps<{
    steps: string[]
    currentStep: string
    showLogoutButton?: boolean
  }>(),
  {
    showLogoutButton: false,
  }
)

defineEmits(['logout'])
</script>

<style scoped>
.flow-background {
  background-image: url('@/assets/images/earth-bottom.png');
  background-position: calc(100% + 5rem) -5.5rem;
  background-size: 27rem auto;
}

@media (min-width: 1280px) {
  .flow-background {
    background-image: url('@/assets/images/earth-and-3-circles.png');
    background-position: calc(100% + 45rem) -10rem;
    background-size: 90rem auto;
  }
}

@media (min-width: 1536px) {
  .flow-background {
    background-image: url('@/assets/images/earth-and-4-circles.png');
    background-position: calc(100% + 30rem) -10rem;
    background-size: 90rem auto;
  }
}
</style>
